'use strict';

import React, { Component } from 'react'

import stripTags from 'striptags'

import Link from '@Pure/Link'

import bemit from '@function/bemit'

let { app } = window;

export default class Notifications extends Component
{
	state =
	{
		loading: false
	};

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const rows = (props.notifications || []).map(function (data)
		{
			let url = '/accueil';

			if (['new_EC_blog', 'updated_EC_blog'].includes(data.type))
			{
				url = '/accueil/mon-espace/blog/' + data.ressource_id;
			}
			else if (['new_product', 'updated_product'].includes(data.type))
			{
				url = '/accueil/catalogue/' + data.ressource_id;
			}
			else if (data.type === 'new_EC_meeting_record')
			{
				url = '/accueil/mon-espace/comptes-rendus-de-reunion/' +
					data.ressource_id;
			}

			// let body = app.getTruncatedText(
			// 	stripTags(
			// 		(data.body || '')
			// 		.split('&nbsp;')
			// 		.join(' ')
			// 		.split('</p>')
			// 		.join('</p> ')
			// 	),
			// 	160,
			// 	true
			// );

			const output =
			(
				<li className="c-notifications__row"
					onClick={ props.onClick } key={ data.type + data.ressource_id }>

					<Link href={ url } className="c-notifications__link"
						onClick={ e => props.setRead(e, data) }>

						<span className="c-notifications__title">
							{ data.title }
						</span>

						{/* <span className="c-notifications__body">
							{ body }
						</span> */}

					</Link>

				</li>
			);

			return output;
		});

		const modifiers = [];

		if (props.open) modifiers.push('open');

		let output =
		(
			<ul className={ bemit('c-notifications', modifiers) }>
				{ rows }

				{
					rows.length === 0 ?
					(
						<li className="c-notifications__all-read">
							Aucune nouvelle notification.
						</li>
					)
					: undefined
				}
			</ul>
		);

		return output;
	}
}